document.addEventListener("DOMContentLoaded", () => {
  const addToCartButton = document.querySelector(
    'button[name="add"].btn--add-to-cart'
  );

  const stickyCart = document.querySelector(".sticky-cart");
  const footer = document.querySelector("footer");

  if (addToCartButton && stickyCart) {
    stickyCart.style.display = "none";

    const checkStickyVisibility = () => {
      const rect = addToCartButton.getBoundingClientRect();

      // Check if footer is in viewport
      let footerInView = false;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        footerInView = footerRect.top < window.innerHeight;
      }

      // Show sticky only if the bottom of the button is above the viewport and footer is not in view
      if (rect.bottom < 0 && !footerInView) {
        stickyCart.style.display = "flex";
      } else {
        stickyCart.style.display = "none";
      }
    };

    window.addEventListener("scroll", checkStickyVisibility);
  }
});
